import { render, staticRenderFns } from "./CustomItemOverview.vue?vue&type=template&id=4e647cac&scoped=true&"
import script from "./CustomItemOverview.vue?vue&type=script&lang=js&"
export * from "./CustomItemOverview.vue?vue&type=script&lang=js&"
import style0 from "./CustomItemOverview.vue?vue&type=style&index=0&id=4e647cac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.10.2_cache-loader@4.1.0_css-loader@3.6.0_vue-template-compiler@2.7.14_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e647cac",
  null
  
)

export default component.exports